import React, { useState } from 'react';
import paymentMethods from '../../../constants/paymentMethodsConfig';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { CheckCircle, XCircle, Trash } from 'react-feather';

const PaymentMethods = ({ onAddPayment, totals = {} }) => {
  const [activeMethod, setActiveMethod] = useState('cash');
  const [amountInput, setAmountInput] = useState('');
  const [payment, setPayment] = useState(null); // single payment only

  const handleConfirm = () => {
    if (!amountInput || isNaN(amountInput) || parseFloat(amountInput) <= 0) return;

    const newPayment = {
      method: activeMethod,
      amount: parseFloat(amountInput),
    };

    setPayment(newPayment);
    onAddPayment(newPayment); // external usage
    resetForm();
  };

  const resetForm = () => {
    setActiveMethod(null);
    setAmountInput('');
  };

  const removePayment = () => {
    setPayment(null);
  };

  const getMethodName = (key) => paymentMethods.find((m) => m.key === key)?.name || key;
  const getMethodIcon = (key) => paymentMethods.find((m) => m.key === key)?.icon;

  return (
    <>
      {!payment && (
        <div className="card payment-method">
          <div className="card-body">
            <h5 className="mb-3">Select Payment</h5>
            <div className="row align-items-center methods g-2">
              {paymentMethods.map((method) => (
                <div className="col-sm-6 col-md-4 d-flex" key={method.key}>
                  <button
                    onClick={() => {
                      if (activeMethod === method.key) {
                        resetForm();
                      } else {
                        setActiveMethod(method.key);
                        setAmountInput(totals.total || '');
                      }
                    }}
                    className={`payment-item d-flex align-items-center justify-content-center p-2 flex-fill ${activeMethod === method.key ? 'active' : ''}`}
                  >
                    <img src={method.icon} className="me-2" alt={method.name} />
                    <p className="fs-14 fw-medium">{method.name}</p>
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      {activeMethod !== null && (
        <div className="card mt-2">
          <div className="card-body">
            <div className="mt-2">
              <input
                className="form-control mb-2"
                aria-label="Amount"
                type="number"
                value={amountInput}
                onChange={(e) => setAmountInput(e.target.value)}
                placeholder="Enter amount"
              />
              <div className="d-flex justify-content-center gap-2">
                <Button
                  type="primary"
                  size="small"
                  onClick={handleConfirm}
                  icon={<CheckCircle size={14} />}
                >
                  Confirm
                </Button>
                <Button
                  danger
                  size="small"
                  onClick={resetForm}
                  icon={<XCircle size={14} />}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {payment && (
        <div className="card mt-3 border-success">
          <div className="card-body">
            <h6 className="mb-2">Payment Confirmed:</h6>
            <div className="d-flex justify-content-between align-items-center border-bottom py-1">
              <div className='d-flex align-items-center'>
                <img
                  src={getMethodIcon(payment.method)}
                  alt={payment.method}
                  width={18}
                  className="me-2"
                />
                <span className="text-muted me-2">
                  {getMethodName(payment.method)}:
                </span>{' '}
                <strong>${payment.amount.toFixed(2)}</strong>
              </div>
              <Button
                className='d-flex align-items-center'
                danger
                type="text"
                size="small"
                onClick={removePayment}
                icon={<Trash size={14} />}
              >
                Remove
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

PaymentMethods.propTypes = {
  onAddPayment: PropTypes.func.isRequired,
  totals: PropTypes.shape({
    total: PropTypes.number,
  }),
};

export default PaymentMethods;
